import React from 'react'
import Img from "../img/img.png";
import Attach from "../img/attach.png";
import { AuthContext } from '../context/AuthContext';
import { ChatContext } from '../context/ChatContext';
import { useContext, useState } from 'react';
import { updateDoc, arrayUnion, Timestamp , doc, serverTimestamp} from "firebase/firestore";
import { v4 as uuidv4 } from 'uuid';
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { toast } from 'react-toastify' 
import {auth, db, provider, storage} from '../config/firebase'
import Picker from 'emoji-picker-react';
const Input = () => {
  const [text, settext] = useState("")
  const [img, setimg] = useState(null)
  const [isemoji, setisemoji] = useState(false)
  const {data} = useContext(ChatContext)
  const {currentuser} = useContext(AuthContext)
  
  const handleemoji = () =>{

    setisemoji(!isemoji)
  }
  
  const handleSend = async() =>{
   if(img){
    const storageRef =  ref(storage, uuidv4());

    await uploadBytesResumable(storageRef, img).then(() => {
      getDownloadURL(storageRef).then(async (downloadURL) => {
      try {
         
        await updateDoc(doc(db, "chats", data.chatId),{

          messages: arrayUnion({
            id: uuidv4(),
            text,
            senderId : currentuser.uid,
            date: Timestamp.now(),
            img : downloadURL,
          })
      });
         }
        catch(err) {
          toast.error(err.message)
        }
      
      });
    });  
   }
   else{
    await updateDoc(doc(db, "chats", data.chatId),{

      messages: arrayUnion({
        id: uuidv4(),
        text,
        senderId : currentuser.uid,
        date: Timestamp.now(),

      })
  });
   }

   await updateDoc(doc(db,"userChats",currentuser.uid),{
     [data.chatId + ".lastMessage"] : {
      text,
     },
     [data.chatId + ".date"] : serverTimestamp(),
   });

   await updateDoc(doc(db,"userChats",data.user.uid),{
    [data.chatId + ".lastMessage"] : {
     text,
    },
    [data.chatId + ".date"] : serverTimestamp(),
  });

  settext("")
  setimg(null)
  }
  return (
    <div className='chat-input'>
      {/* style={{display: isemoji ? "inline" : "none"}} */}
        <div className='emoji-picker' style={{display: isemoji ? "inline" : "none"}}  >
        <Picker onEmojiClick={(emojiObject) => settext((prevMsg)=> prevMsg + emojiObject.emoji)} />
      </div> 
      
      <div className='emoji-icon' style={{fontSize:"1.5rem", fontWeight:"700", cursor:"pointer"}} onClick={handleemoji}>
      ☺
      </div>
      <input 
      type='text' 
      placeholder='Write a message' 
      onChange={(e) =>{ settext(e.target.value)}}
      value={text}
      />
      
      <div className="send">
        <img src={Attach} alt="" />
        <input
          type="file"
          style={{ display: "none" }}
          id="file"
          onChange={(e) =>{ setimg(e.target.files[0])}}
        />
        <label htmlFor="file">
          <img src={Img} alt="" />
        </label>
        <button  onClick={handleSend}>Send</button>
      </div>
    </div>
  )
}

export default Input